import React, { FC, useCallback } from 'react';
import styles from './index.module.scss';
import { Avatar, TenderStatusBadge } from 'src/common';
import { ActivePreviewTab } from 'src/models/procurements/types';
import { useOpenTenderPreview } from 'src/models/procurements/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/pro-light-svg-icons';
import { TendersBoardItem } from 'src/models/procurements/TendersViews';

interface IProps {
  tender: TendersBoardItem;
}

const Badges: FC<IProps> = props => {
  const { tender } = props;
  const { id, assignedTo, procurementStatus, isCommented } = tender;
  const openTenderPreview = useOpenTenderPreview();

  const onOpenPreview = useCallback(() => {
    openTenderPreview(id, ActivePreviewTab.Comments);
  }, [id, openTenderPreview]);

  return (
    <ul className={styles.list}>
      <TenderStatusBadge
        className={styles.tenderStatusBadge}
        statuses={procurementStatus}
        wrapper={({ children }) => <li className={styles.item}>{children}</li>}
      />
      {isCommented && (
        <li className={styles.item}>
          <button onClick={onOpenPreview} className={styles.button}>
            <FontAwesomeIcon icon={faCommentDots} />
          </button>
        </li>
      )}
      {assignedTo && (
        <li className={styles.item}>
          <Avatar user={assignedTo} showTooltip size={'m'} />
        </li>
      )}
    </ul>
  );
};

export default Badges;
